<template>
  <div class="bg-gray-50 min-h-screen">
    <!-- 全局悬浮组件 -->
    <SideFloat />

    <!-- 页面标题区 -->
    <section class="relative h-[400px] md:h-[500px] overflow-hidden">
      <img 
        src="@/assets/images/technology.jpg" 
        alt="Zhengzhou Anjing New Material Technology Co., Ltd. Factory"
        class="w-full h-full object-cover"
      >
      <div class="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
        <div class="text-center text-white px-6">
          <h2 class="text-3xl md:text-5xl font-bold mb-4">Company Profile</h2>
          <p class="text-lg md:text-xl max-w-3xl mx-auto">Committed to creating a quiet world with innovative acoustic materials and professional solutions</p>
        </div>
      </div>
    </section>

    <!-- 公司简介内容区 -->
    <section class="py-12">
      <div class="container mx-auto px-6">
        <!-- 公司简介卡片 -->
        <div class="bg-white p-8 rounded-lg shadow-md mx-auto">
          <div class="prose max-w-none text-gray-700">
            <!-- 公司核心介绍 -->
            <p class="mb-6 text-lg leading-relaxed">
              Zhengzhou SoundProof New Materials Technology Co., Ltd. is a manufacturing enterprise specializing in the production of damping sound insulation felt. The registered trademark of the sound insulation felt produced is "Jinyaque".
            </p>

            <!-- 企业定位与理念 -->
            <p class="mb-6 text-lg leading-relaxed">
              Based in Zhengzhou, the hinterland of the Central Plains, and radiating the global acoustic blue ocean, Zhengzhou SoundProof New Materials Technology Co., Ltd. takes "Technological Noise Reduction, Building Boundless Beauty" as its core philosophy, deeply cultivates the field of damping sound insulation materials, and strives to become a leader in acoustic solutions integrating R&D, production and global supply.
            </p>

            <!-- 制造哲学与产品优势 -->
            <p class="mb-6 text-lg leading-relaxed">
              Adhering to the manufacturing philosophy of "Precise Research for Perfection, Sound Protection for the Future", the company focuses its core technologies on the performance iteration and scenario adaptation of damping sound insulation felt. The "Jinyaque" brand damping sound insulation felt under the company endows diverse spaces with two-color aesthetics, suitable for scenarios with high noise requirements such as large mechanical equipment, KTVs, hotels and bars, live broadcast rooms, recording studios, residences, hospitals, etc.; the sound insulation felt also meets the heavy-duty noise reduction needs of industrial computer rooms, commercial offices, transportation hubs and other places. Simultaneously, it launches three precisely thickness specifications of sound insulation felt: 1.2mm compact type, 2mm balanced type and 3mm high-efficiency type. Relying on the dual core principles of "quality + damping", it efficiently converts sound energy into heat energy consumption, with a measured noise reduction of 25-40dB, cutting off air and solid sound transmission from the source, and building a millimeter-level quiet barrier for every space.
            </p>

            <!-- 品质保障 -->
            <p class="mb-6 text-lg leading-relaxed">
              The excellent quality of "Jinyaque" stems from strict adherence to the entire chain. It has passed SGS environmental certification and GB/T20219-2006 national standard, with lead content far lower than international limits. The production link builds an automated intelligent production line, realizing physical forming through high-temperature calendering composite technology. The product maintains stable performance without cracking or aging in a wide temperature range of -30℃~80℃, and has multiple advantages such as waterproof and moisture-proof, fire and flame retardant (B1 grade). The "Jinyaque" brand damping sound insulation felt complies with ul94-v0 standard.
            </p>

            <!-- 全球化布局 -->
            <p class="mb-6 text-lg leading-relaxed">
              Upholding a global strategic vision, the company has built a marketing service network covering Europe, America, Southeast Asia, the Middle East and other countries and regions. With excellent sound insulation performance, reliable quality stability and flexible customized services, "Jinyaque" sound insulation felt has always delivered consistent high quality from domestic green buildings to international acoustic engineering, conveying the technological confidence and brand strength of Chinese new materials.
            </p>

            <!-- 未来展望 -->
            <p class="mb-0 text-lg leading-relaxed">
              In the future, Zhengzhou SoundProof New Materials Technology Co., Ltd. will continue to take the "Jinyaque" brand as the core, deepen the innovation track of sound insulation materials, integrate the concepts of green intelligent manufacturing and global services, continuously break through technical bottlenecks, expand application boundaries, and commit to bringing more efficient, environmentally friendly and aesthetically valuable sound insulation solutions to the world, allowing every space to embrace the beauty of tranquility.
            </p>
          </div>
        </div>

        <!-- 品牌核心信息卡片 -->
        <div class="bg-white p-8 rounded-lg shadow-md mx-auto mt-8">
          <h2 class="text-2xl font-bold text-gray-800 mb-6">Core Information</h2>
          <ul class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <li class="flex items-start">
              <div class="w-12 h-12 bg-primary/10 text-primary rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                <i class="fa fa-building text-xl"></i>
              </div>
              <div>
                <h3 class="font-medium text-gray-800 mb-1">Company Name</h3>
                <p class="text-gray-600">Zhengzhou SoundProof New Materials Technology Co., Ltd.</p>
              </div>
            </li>
            <li class="flex items-start">
              <div class="w-12 h-12 bg-primary/10 text-primary rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                <i class="fa fa-trademark text-xl"></i>
              </div>
              <div>
                <h3 class="font-medium text-gray-800 mb-1">Brand Name</h3>
                <p class="text-gray-600">Jinyaque</p>
              </div>
            </li>
            <li class="flex items-start">
              <div class="w-12 h-12 bg-primary/10 text-primary rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                <i class="fa fa-lightbulb-o text-xl"></i>
              </div>
              <div>
                <h3 class="font-medium text-gray-800 mb-1">Core Philosophy</h3>
                <p class="text-gray-600">Technological Noise Reduction, Building Boundless Beauty</p>
              </div>
            </li>
            <li class="flex items-start">
              <div class="w-12 h-12 bg-primary/10 text-primary rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                <i class="fa fa-industry text-xl"></i>
              </div>
              <div>
                <h3 class="font-medium text-gray-800 mb-1">Main Product</h3>
                <p class="text-gray-600">Damping Sound Insulation Felt (1.2mm/2mm/3mm)</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import SideFloat from '@/components/SideFloat.vue'
import { ref, onMounted } from 'vue'
import { indexSet } from '@/api/index'

const set = ref({})

onMounted(() => {
  getIndexSet()
})

// 获取站点配置（保持原有逻辑，可用于动态展示公司联系信息）
const getIndexSet = async () => {
  try {
    let res = await indexSet()
    set.value = res.data || {}
    console.log('站点配置:', set.value)
  } catch (error) {
    console.error('获取站点配置失败:', error)
  }
}
</script>

<style scoped>
/* 文本排版优化 */
.prose {
  line-height: 1.8;
}

.prose p {
  margin-bottom: 1.5rem;
  text-align: justify;
}

/* 响应式字体大小 */
@media (max-width: 768px) {
  .prose p {
    font-size: 1rem;
    line-height: 1.6;
  }
  
  .bg-white.p-8 {
    padding: 16px;
  }
}

/* 平滑过渡效果 */
* {
  transition: all 0.2s ease-in-out;
}

/* 列表项样式优化 */
li {
  transition: transform 0.2s ease;
}

li:hover {
  transform: translateY(-2px);
}

/* 标题区响应式优化 */
@media (max-width: 768px) {
  section.relative h-[400px] {
    height: 300px;
  }
  
  h2.text-3xl {
    font-size: 2xl;
  }
  
  p.text-lg {
    font-size: base;
  }
}
</style>